export default __webpack_public_path__ + "static/media/mentoriaMarca.3f2fb061.png";